import funLogoImage from 'assets/images/pink-square-logo.png';
import cx from 'classnames';
import { resourceUrl } from 'helpers/url.helper';
import React, { FC, HtmlHTMLAttributes } from 'react';
import { useAppSelector } from 'store/store-hooks';
import './loader.css';

export type LoaderProps = HtmlHTMLAttributes<HTMLDivElement> & {
  loading?: boolean;
  wrapperChildren?: React.ReactElement | string;
  spin?: React.ReactElement | string;
  outerSpinProps?: HtmlHTMLAttributes<HTMLDivElement>;
};

const Loader: FC<LoaderProps> = ({
  children,
  wrapperChildren,
  loading = false,
  spin = null,
  outerSpinProps,
  ...props
}) => {
  const { boothInfo } = useAppSelector((s) => s.booth);

  return (
    <div
      {...props}
      className={cx('pb-loader', props?.className, {
        loading,
      })}
    >
      {children}
      {loading && (
        <div
          {...outerSpinProps}
          className={cx('pb-loader-icon-wrapper', outerSpinProps?.className)}
        >
          {spin || (
            <img
              src={
                boothInfo?.LogoImageUrl
                  ? resourceUrl(boothInfo?.LogoImageUrl)
                  : funLogoImage
              }
              className="pb-loader-img animate-scale-pulse mx-auto relative"
              alt="logo fun"
            />
          )}
          {wrapperChildren}
        </div>
      )}
    </div>
  );
};

export default Loader;
